module.exports = __webpack_public_path__ + "ENG_SPT9-Book_225002585-2a1ed7ac580a4b37b2099551139e59df.png";